import React, { useState, useEffect, useContext } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { createMuiTheme, Slide, Container, Dialog, Toolbar, IconButton, Typography, Fab, CssBaseline, Backdrop, CircularProgress, Grid, AppBar } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { Context } from "../../contexts/siteContext";
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import AddUnitLocation from "../unit/unitLocationAdd";
import ConfirmDialog from '../../common/confirmDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function UnitLocation(props) {
    const classes = useStyles();
    const unitId = props.model.length === 0 ? 0 : props.model.Id;
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [backDrop, setBackDrop] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [addLocationOpen, setAddLocationOpen] = useState(false);
    const [unitLocations, setUnitLocations] = useState([]);
    const [id, setId] = useState();
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (row, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const handleClose = () => {
        setAddLocationOpen(false);
    };

    const handleUnitLocationClose = () => {
        props.parentCallback();
    };

    const getUnitLocations = () => {
        setBackDrop(true);
        HttpService.post('/Unit/GetUnitLocations', {
            UnitId: unitId,
            SiteCode: defaultSite.id
        })
            .then((result) => {
                setUnitLocations(result.data);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    const addLocation = () => {
        setAddLocationOpen(true);
    };

    const deleteLocation = (id) => {
        setId(id);
        setConfirmOpen(true);
    };

    const deleteUnitLocation = () => {
        setConfirmOpen(false);
        HttpService.post('/Unit/DeleteUnitLocation', { Id: id })
            .then((result) => {
                const data = unitLocations.filter(unitLocations => unitLocations.Id !== id);
                setUnitLocations(data);
            },
                (error) => {
                    console.log(error);
                });
    };

    useEffect(() => {
        getUnitLocations();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        const columns = [
            {
                dataField: 'Id',
                text: 'ID',
                sort: true,
                hidden: true,
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                }
            },
            {
                dataField: "rowNumber",
                text: '#',
                formatter: (cellContent, row, index) => { return (<div>{index + 1}</div>); },
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground,
                    width: '50px'
                }
            },
            {
                dataField: 'LocationName',
                text: 'Name',
                sort: true,
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                }
            },
            {
                dataField: 'df2',
                text: '',
                isDummyField: true,
                headerStyle: {
                    width: '70px',
                    background: currentTheme.headerBackground
                },
                formatter: (cellContent, row) => {
                    return (<div style={{ display: 'flex' }}>
                        <DeleteIcon style={{ color: currentTheme.secondary, cursor: 'pointer' }} onClick={() => deleteLocation(row.Id)} />
                    </div>
                    );
                }
            }
        ];
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="locationBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={addLocationOpen} onClose={handleClose} TransitionComponent={Transition}>
                        <AddUnitLocation parentCallback={handleClose}
                            refreshGrid={getUnitLocations}
                            model={props.model}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={handleUnitLocationClose} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>Unit Locations</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={addLocation}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <BootstrapTable bootstrap4 keyField='Id' rowStyle={rowStyle} data={unitLocations} columns={columns} hover noDataIndication="No records found" />
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deleteUnitLocation}
                                    title="Delete Unit Location" message="Are you sure you want to delete the selected Unit Location?" />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
